import { Flex } from 'antd';
import { useCompanyContext } from 'contexts/CompanyContext';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const { companyConfig } = useCompanyContext();

  return (
    <>
      <div className="footer">
        <Flex vertical={true} className="text-center" gap={14}>
          <Flex className="footer-links" justify="center" gap={20}>
            <Link to={companyConfig.privacyUrl} target="_blank" rel="noopener noreferrer">
              Privacy
            </Link>
            |
            <Link to={companyConfig.termsUrl} target="_blank" rel="noopener noreferrer">
              Terms
            </Link>
            <span className="footer-link-desktop-only">|</span>
            <Link to={'/faq'} className="footer-link-desktop-only">
              FAQ
            </Link>
            <span className="footer-link-desktop-only">|</span>
            <Link to={'/contact-us'} className="footer-link-desktop-only">
              Contact
            </Link>
            {companyConfig.donationUrl && (
              <>
                |
                <Link to={companyConfig.donationUrl} target="_blank" rel="noopener noreferrer">
                  Donate
                </Link>
              </>
            )}
            {companyConfig.volunteerUrl && (
              <>
                <span className="footer-link-desktop-only">|</span>
                <Link to={companyConfig.volunteerUrl} target="_blank" rel="noopener noreferrer" className="footer-link-desktop-only">
                  Volunteer
                </Link>
              </>
            )}
          </Flex>

          <div className="copyright">{companyConfig.footerText}</div>
        </Flex>
      </div>
    </>
  );
}

export default Footer;
